import { Injectable } from '@angular/core';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataColumn } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableDataColumnExtractor } from 'app/modules/main/components/data-selector/data-selector.models';
import { PublisherAccount } from 'app/modules/main/models/account';
import { of } from 'rxjs';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PublisherColumnExtractor implements SelectableDataColumnExtractor<PublisherAccount> {

  // select control column width is 13%
  //  -- all columns should add up to 100%
  readonly columns: SelectableDataColumn[] = [
    {
      headingLabel: $localize`:@@communication-centre.advertiser.publisher-selector.column.id.label:ID`,
      headingStyle: { width: '14%' },
      valueStyle: { width: '14%' }
    },
    {
      headingLabel: $localize`:@@communication-centre.advertiser.publisher-selector.column.publisher.label:Publisher`,
      headingStyle: { width: '73%' },
      valueStyle: { width: '73%' }
    },
  ];

  getValue(
    index: number,
    selectablePublisher: SelectableData<PublisherAccount>
  ): Observable<string> {

    switch (index) {

      case 0:
        return of(selectablePublisher.id);

      case 1:
        return of(selectablePublisher.label);

      default:
        return of('');
    }
  }

}
